import { createSelector } from 'reselect';
import { selectCurrentOrigin } from '../location/selectors';

export const selectNavigationSubstore = (state) => state.Navigation;

export const selectLocationSubStore = (state) => state.location;

export const selectCurrentLocation = createSelector(
  [selectLocationSubStore, selectCurrentOrigin],
  (location, currentOrigin) =>
    `${currentOrigin}${location.pathname}${
      location.search ? `?${location.search}` : ''
    }`
);

export const selectNumWarningsAboutAppExit = createSelector(
  selectNavigationSubstore,
  (navigation) => navigation.get('numWarningsAboutAppExit', 0)
);
